import React from 'react';

import PropTypes from 'prop-types';

import styled, { css } from 'styled-components';

import colors from 'theme/colors';
import fonts from 'theme/fonts';
import media from 'theme/media';

const getTextColor = (props) => {
    switch (props.color) {
        case 'darkGray':
            return props.useThemeColor ? props.theme.black : colors.baseColor;
        case 'mediumGray':
            return props.useThemeColor ? props.theme.grey_72_lc : colors.mediumGray;
        case 'purple':
            return props.useThemeColor ? props.theme.purple_100 : colors.purple;
        case 'red':
            return props.useThemeColor ? props.theme.pink_100 : colors.red;
        default:
            return props.useThemeColor ? props.theme.black : colors.baseColor;
    }
};

const getMobileSize = (props) => {
    switch (props.size) {
        case 'header':
            return '24px';
        case 'secondary':
            return '14px';
        default:
            return '17px';
    }
};
const getMobileLineHeight = (props) => {
    switch (props.size) {
        case 'header':
            return '36px';
        case 'secondary':
            return '20px';
        default:
            return '24px';
    }
};
const getDesktopSize = (props) => {
    switch (props.size) {
        case 'header':
            return '32px';
        case 'secondary':
            return '17px';
        default:
            return '20px';
    }
};
const getDesktopLineHeight = (props) => {
    switch (props.size) {
        case 'header':
            return '48px';
        case 'secondary':
            return '24px';
        default:
            return '32px';
    }
};

const getComponent = (variant) => {
    switch (variant) {
        case 'h2':
            return TextHeader2;
        case 'paragraph':
            return TextParagraph;
        case 'div':
            return TextDiv;
        default:
            return TextSpan;
    }
};

const CommonCss = css`
    font-family: ${fonts.regular};
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    font-size: ${(props) => getMobileSize(props)};
    line-height: ${(props) => getMobileLineHeight(props)};
    color: ${(props) => getTextColor(props)};
    white-space: ${(props) => (props.nowrap || props.ellipsis ? 'nowrap' : null)};
    overflow: ${(props) => (props.ellipsis ? 'hidden' : null)};
    text-overflow: ${(props) => (props.ellipsis ? 'ellipsis' : null)};
    max-width: ${(props) => (props.ellipsis ? '100%' : null)};

    &:link,
    &:visited {
        color: ${(props) => getTextColor(props)};
    }

    ${media.tablet648} {
        font-size: ${(props) => getDesktopSize(props)};
        line-height: ${(props) => getDesktopLineHeight(props)};
    }
`;

const TextSpan = styled.span`
    ${CommonCss};
`;
const TextDiv = styled.div`
    ${CommonCss};
`;
const TextHeader2 = styled.h2`
    ${CommonCss};
`;
const TextParagraph = styled.p`
    ${CommonCss};
`;

export const LightText = (props) => {
    const Wrapper = getComponent(props.variant);
    return (
        <Wrapper {...props} data-testid={props.dataTestId}>
            {props.children}
        </Wrapper>
    );
};

LightText.propTypes = {
    variant: PropTypes.oneOf(['h2', 'paragraph', 'div', 'span']),
    color: PropTypes.oneOf(['darkGray', 'mediumGray', 'purple', 'red']),
    size: PropTypes.oneOf(['header', 'main', 'secondary']),
    nowrap: PropTypes.bool,
    ellipsis: PropTypes.bool,
    useThemeColor: PropTypes.bool,
};
